import type { TypeUploadBody } from '../types';

// ----------------------------------------------------------------------------

function getBodySize(body: TypeUploadBody): number {
    if (body instanceof Blob) {
        return body.size;
    }
    if (body instanceof ArrayBuffer) {
        return body.byteLength;
    }
    if (body instanceof Uint8Array) {
        return body.byteLength;
    }
    if (typeof body === 'string') {
        return new TextEncoder().encode(body).byteLength;
    }
    return 0;
}

// ----------------------------------------------------------------------------

export default getBodySize;
